import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';

type ResourceTemplateModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (templateName: string) => Promise<void>;
};

export default function FlattenModal({
  isOpen,
  onClose,
  onSubmit,
}: ResourceTemplateModalProps): React.ReactElement {
  type ResourceTemplateFormValues = {
    templateName: string;
  };

  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
    reset,
  } = useForm<ResourceTemplateFormValues>({
    defaultValues: {
      templateName: '',
    },
  });

  const onSubmitInternal = handleSubmit(async ({ templateName }) => {
    await onSubmit(templateName);
    onClose();
    reset();
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Create item template</ModalHeader>
        <Divider orientation="horizontal" />
        <ModalBody>
          <form id="resource-template-form" onSubmit={onSubmitInternal}>
            <FormControl isRequired>
              <FormLabel>Enter a template name</FormLabel>
              <Input
                autoFocus
                {...register('templateName')}
                placeholder="Template name"
                type="text"
              ></Input>
            </FormControl>
          </form>
        </ModalBody>
        <Divider orientation="horizontal" />
        <ModalFooter gap={2}>
          <Button
            isLoading={isSubmitting}
            type="submit"
            form="resource-template-form"
          >
            Create template
          </Button>
          <Button colorScheme="gray" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
